import React, { useState, useEffect } from 'react';
import { useAuth } from '../hooks/useAuth';
import { useTheme } from '../hooks/useTheme';
import { getUserStats } from '../services/firestore';

const Dashboard = () => {
    const { user } = useAuth();
    const { darkMode } = useTheme();
    const [stats, setStats] = useState({
        totalWorkouts: 0,
        totalPoints: 0,
        streak: 0,
        recentWorkouts: []
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchStats = async () => {
            if (user) {
                try {
                    const userStats = await getUserStats(user.uid);
                    setStats(userStats);
                } catch (error) {
                    console.error('Error fetching stats:', error);
                } finally {
                    setLoading(false);
                }
            }
        };

        fetchStats();
    }, [user]);

    if (loading) {
        return (
            <div className="max-w-7xl mx-auto px-4 py-8">
                <div className={`text-center ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>Loading...</div>
            </div>
        );
    }

    return (
        <div className="max-w-7xl mx-auto px-4 py-8">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {/* Stats Cards */}
                <div className={`${darkMode ? 'bg-gray-800' : 'bg-white'} rounded-lg shadow p-6`}>
                    <div className="flex items-center">
                        <div className="flex-shrink-0">
                            <div className="w-8 h-8 bg-blue-500 rounded-md flex items-center justify-center text-white font-bold">
                                💪
                            </div>
                        </div>
                        <div className="ml-4">
                            <p className={`text-sm font-medium ${darkMode ? 'text-gray-400' : 'text-gray-600'}`}>Total Workouts</p>
                            <p className={`text-2xl font-bold ${darkMode ? 'text-white' : 'text-gray-900'}`}>{stats.totalWorkouts}</p>
                        </div>
                    </div>
                </div>

                <div className={`${darkMode ? 'bg-gray-800' : 'bg-white'} rounded-lg shadow p-6`}>
                    <div className="flex items-center">
                        <div className="flex-shrink-0">
                            <div className="w-8 h-8 bg-green-500 rounded-md flex items-center justify-center text-white font-bold">
                                🔥
                            </div>
                        </div>
                        <div className="ml-4">
                            <p className={`text-sm font-medium ${darkMode ? 'text-gray-400' : 'text-gray-600'}`}>Current Streak</p>
                            <p className={`text-2xl font-bold ${darkMode ? 'text-white' : 'text-gray-900'}`}>{stats.streak} days</p>
                        </div>
                    </div>
                </div>

                <div className={`${darkMode ? 'bg-gray-800' : 'bg-white'} rounded-lg shadow p-6`}>
                    <div className="flex items-center">
                        <div className="flex-shrink-0">
                            <div className="w-8 h-8 bg-purple-500 rounded-md flex items-center justify-center text-white font-bold">
                                🏆
                            </div>
                        </div>
                        <div className="ml-4">
                            <p className={`text-sm font-medium ${darkMode ? 'text-gray-400' : 'text-gray-600'}`}>Points</p>
                            <p className={`text-2xl font-bold ${darkMode ? 'text-white' : 'text-gray-900'}`}>{stats.totalPoints}</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Recent Activity */}
            <div className="mt-8">
                <h2 className={`text-lg font-medium ${darkMode ? 'text-white' : 'text-gray-900'} mb-4`}>Recent Activity</h2>
                <div className={`${darkMode ? 'bg-gray-800' : 'bg-white'} rounded-lg shadow`}>
                    {stats.recentWorkouts.length > 0 ? (
                        <div className={`divide-y ${darkMode ? 'divide-gray-700' : 'divide-gray-200'}`}>
                            {stats.recentWorkouts.map((workout) => (
                                <div key={workout.id} className="p-6">
                                    <div className="flex justify-between items-center">
                                        <div>
                                            <p className={`text-sm font-medium ${darkMode ? 'text-white' : 'text-gray-900'}`}>
                                                {workout.totalExercises} exercises
                                            </p>
                                            <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                                                {new Date(workout.date).toLocaleDateString()}
                                            </p>
                                        </div>
                                        <div className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                                            {workout.points} points
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className={`p-6 text-center ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                            <p>No workouts yet. Add your first workout to get started! 💪</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Dashboard;